import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getLanguage } from "../../store/rootReducer";
import CardWidget from "../card-widget/CardWidget";
import _forOwn from 'lodash/forOwn';
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import EmailField from "./fields/EmailField";
import PasswordField from "./fields/PasswordField";
import FirstNameField from "./fields/FirstNameField";
import LastNameField from "./fields/LastNameField";
import ProvinceDropdown from "./fields/ProvinceDropdown";
import SecurityQuestionDropdown from "./fields/SecurityQuestionDropdown";
import SecurityQuestionAnswer from "./fields/SecurityQuestionAnswer";
import SecurityQuestionHint from "./fields/SecurityQuestionHint";
import PhoneNumber from "./fields/PhoneNumber";
import {RouteConstants} from "../route/services/RouteConstants";
import auth from "../../services/auth/AuthProvider";

class RegistrationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showExtraInfo: false,
            formErrors: {
                password: {
                    error: '',
                    showError: false
                },
                email: {
                    error: '',
                    showError: false
                },
                firstName: {
                    error: '',
                    showError: false
                },
                lastName: {
                    error: '',
                    showError: false
                },
                province: {
                    error: '',
                    showError: false
                },
                securityQuestion: {
                    error: '',
                    showError: false
                },
                securityQuestionAnswer: {
                    error: '',
                    showError: false
                },
                securityQuestionHint: {
                    error: '',
                    showError: false
                },
                phoneNumber: {
                    error: '',
                    showError: false
                },
                recoveryEmail: {
                    error: '',
                    showError: false
                }
            },
            showErrorForField: {
                password: false,
                email: false
            },
            isLoading: false,
        };
        this.registrationForm = {};
    }

    goToRoute = (route) => {
        this.props.history.push(`${route}`);
    };

    hasErrors = () => {
        let formErrors = { ...this.state.formErrors };
        let hasError = false;
        _forOwn(formErrors, (value, key) => {
            if (value.error) {
                hasError = true;
                return false;
            }
        });
        return hasError;
    };

    showErrors = () => {
        let formErrors = { ...this.state.formErrors };
        _forOwn(formErrors, (value, key) => {
            formErrors[key].showError = true;
        });
        this.setState({
            formErrors: formErrors
        });
    };

    onEmailChange = (e, errorMessage) => {
        this.registrationForm.email = e.target.value;
        this.registrationForm.userName = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                email: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onPasswordChanged = (password, errorMessage) => {
        this.registrationForm.password = password;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                password: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onFirstNameChanged = (e, errorMessage) => {
        this.registrationForm.firstName = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                firstName: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onLastNameChanged = (e, errorMessage) => {
        //TODO: there is no last name field in the database, need to add this
        this.registrationForm.lastName = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                lastName: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onProvinceSelected = (e, errorMessage) => {
        this.registrationForm.province = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                province: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onSecurityQuestionSelected = (e, errorMessage) => {
        this.registrationForm.securityQuestion = e.target.value;
        let showExtraInfo = !!e.target.value;
        this.setState((state, props) => ({
            showExtraInfo: showExtraInfo,
            formErrors: {
                ...state.formErrors,
                securityQuestion: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onSecurityQuestionAnswerChanged = (e, errorMessage) => {
        this.registrationForm.securityAnswer = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                securityQuestionAnswer: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onSecurityQuestionHintChanged = (e, errorMessage) => {
        this.registrationForm.securityHint = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                securityQuestionHint: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onPhoneNumberChanged = (e, errorMessage) => {
        if (!e.target.value) {
            this.registrationForm.phoneNumber = null;
        } else {
            this.registrationForm.phoneNumber = e.target.value;
        }
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                phoneNumber: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onRecoveryEmailChanged = (e, errorMessage) => {
        this.registrationForm.alternateEmail = e.target.value;
        this.setState((state, props) => ({
            formErrors: {
                ...state.formErrors,
                recoveryEmail: {
                    showError: false,
                    error: errorMessage
                }
            }
        }));
    };

    onRegistrationRequestFinished = (response) => {
        if (response.data.doesEmailAlreadyExist) {
            this.setState((state, props) => ({
                isLoading: false,
                formErrors: {
                    ...state.formErrors,
                    email: {
                        showError: true,
                        error: 'registration.error_email_exists'
                    }
                }
            }));
            return;
        }

        if (response.data.oneTimeCode) {
            return auth.otcAuthentication(response.data.oneTimeCode, this.registrationForm.userName).then(() => {
                this.goToRoute(RouteConstants.DASHBOARD);
            }).catch((e) => {
                auth.login(this.props.language);
            }).finally(() => {
                this.setState({
                    isLoading: false
                });
            });
        } else {
            auth.login(this.props.language);
        }
    };

    makeRegistrationRequest = () => {
        Api.post(ApiPaths.REGISTER, { ...this.registrationForm, lang: this.props.language }).then((response) => {
            this.onRegistrationRequestFinished(response);
        }).catch((e) => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        });
    };

    register = (e) => {
        this.setState({
            isLoading: true
        });
        if (this.hasErrors()) {
            this.showErrors();
            this.setState({
                isLoading: false
            });
            console.log(this.state);
            return;
        }
        this.registrationForm.lang = this.props.language;
        this.makeRegistrationRequest();
        e.preventDefault();
    };

    getOnSecurityQuestionSelectedContent = () => {
        return (
            <React.Fragment>
                <SecurityQuestionAnswer
                    onChange={this.onSecurityQuestionAnswerChanged}
                    fieldLabel="registration.security_question_answer_label"
                    showErrors={this.state.formErrors.securityQuestionAnswer.showError}
                />
                <SecurityQuestionHint
                    answer={this.registrationForm.securityAnswer}
                    fieldLabel="registration.security_question_hint_label"
                    onChange={this.onSecurityQuestionHintChanged}
                    showErrors={this.state.formErrors.securityQuestionHint.showError}
                />
                <PhoneNumber
                    onChange={this.onPhoneNumberChanged}
                    fieldLabel="registration.phone_number_label"
                    showErrors={this.state.formErrors.phoneNumber.showError}
                />
                <EmailField
                    showErrors={this.state.formErrors.recoveryEmail.showError}
                    fieldLabel="registration.recover_email_label"
                    onChange={this.onRecoveryEmailChanged}
                    isRequired={false}
                />
            </React.Fragment>
        )
    };

    getCardContent = () => {
        return (
            <form onSubmit={this.register}>
                <EmailField
                    onChange={this.onEmailChange}
                    fieldLabel="registration.email_label"
                    showErrors={this.state.formErrors.email.showError}
                    isRequired={true}
                    errorMessage={this.state.formErrors.email.error}
                />
                <PasswordField
                    onChange={this.onPasswordChanged}
                    fieldLabel="registration.password_label"
                    showErrors={this.state.formErrors.password.showError}
                />
                <FirstNameField
                    onChange={this.onFirstNameChanged}
                    fieldLabel="registration.first_name_label"
                    showErrors={this.state.formErrors.firstName.showError}
                />
                <LastNameField
                    onChange={this.onLastNameChanged}
                    fieldLabel="registration.last_name_label"
                    showErrors={this.state.formErrors.lastName.showError}
                />
                <ProvinceDropdown
                    onChange={this.onProvinceSelected}
                    fieldLabel="registration.province_label"
                    showErrors={this.state.formErrors.province.showError}
                />
                <SecurityQuestionDropdown
                    onChange={this.onSecurityQuestionSelected}
                    fieldLabel="registration.security_question_label"
                    showErrors={this.state.formErrors.securityQuestion.showError}
                />
                {this.state.showExtraInfo
                    && this.getOnSecurityQuestionSelectedContent()}
            </form>
        );
    };

    render() {
        return (
            <CardWidget
                mobileSideTitle="registration.welcome_text"
                mobileSideSubTitle="registration.welcome_sub_text"
                getCardContent={this.getCardContent}
                submitButtonAction={this.register}
                submitButtonText="registration.submit_button"
                isFormSubmitLoading={this.state.isLoading}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: getLanguage(state)
    }
};

export default connect(mapStateToProps)(RegistrationForm);